import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Thread, api } from "../api";

const stateColor: Record<string, string> = {
  open: "bg-blue-100 text-blue-800",
  awaiting_human: "bg-amber-100 text-amber-800",
  won: "bg-green-100 text-green-800",
  lost: "bg-ink-100 text-ink-500",
  closed: "bg-ink-100 text-ink-500",
};

export default function Inbox() {
  const [threads, setThreads] = useState<Thread[] | null>(null);
  const [filter, setFilter] = useState<string>("");

  useEffect(() => {
    const q = filter ? `?state=${filter}` : "";
    api<{ threads: Thread[] }>(`/api/threads${q}`)
      .then((r) => setThreads(r.threads))
      .catch((e) => alert(e.message));
  }, [filter]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Inbox</h1>
        <select className="input w-auto" value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="">All states</option>
          <option value="open">Open</option>
          <option value="awaiting_human">Awaiting human</option>
          <option value="won">Won</option>
          <option value="lost">Lost</option>
          <option value="closed">Closed</option>
        </select>
      </div>

      {!threads ? (
        <div className="text-sm text-ink-500">loading…</div>
      ) : threads.length === 0 ? (
        <div className="card p-10 text-center text-sm text-ink-500">
          No threads yet. Once campaigns start sending, replies will land here.
        </div>
      ) : (
        <div className="card divide-y divide-ink-200">
          {threads.map((t) => (
            <Link key={t.id} to={`/threads/${t.id}`} className="flex items-center justify-between px-4 py-3 hover:bg-ink-50">
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`pill ${stateColor[t.state] ?? "bg-ink-100"}`}>{t.state.replace("_", " ")}</span>
                  <span className="font-medium truncate">{t.subject || "(no subject)"}</span>
                </div>
                <div className="text-xs text-ink-500 mt-0.5 truncate">
                  {t.contact_email && <span className="font-mono mr-2">{t.contact_email}</span>}
                  {t.campaign_name && (
                    <span>· campaign: <span className="text-ink-700">{t.campaign_name}</span></span>
                  )}
                </div>
              </div>
              <div className="text-xs text-ink-500 whitespace-nowrap ml-3">
                {t.last_inbound_at ? new Date(t.last_inbound_at * 1000).toLocaleString() : "—"}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
